import { render, staticRenderFns } from "./ShadowBoxTitleDescription.vue?vue&type=template&id=121eb4fa&scoped=true&"
import script from "./ShadowBoxTitleDescription.vue?vue&type=script&lang=js&"
export * from "./ShadowBoxTitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./ShadowBoxTitleDescription.vue?vue&type=style&index=0&id=121eb4fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121eb4fa",
  null
  
)

export default component.exports